import React from 'react'
import { createRoot } from 'react-dom/client'

import 'url-search-params-polyfill'

import {
  dedupeAndRemoveEscapeChar,
  setAndSortModalCategories,
} from './Helper/SubscriptionUtility.js'
import { updateSubscriptionData } from '../Landing/Helper/helper.js'
import { isLoggedIntoSubscriptionCenter } from '../../../global/authentication/authentication-manager.js'
import {
  getSubscriptionsByNameList,
  getSubscriptionsForUser,
} from '../Data/SubscriptionCenterDataSource.js'
import ModalButton from './ModalButton.jsx'
import SubscribeModalButton from './SubscribeModalButton.jsx'

class EmailSubscriptionCenterModalElement extends HTMLElement {
  async connectedCallback() {
    let subscriptions, subscriptionProfile
    let buttonStyle = this.getAttribute('tertiary')
      ? 'tertiary'
      : this.getAttribute('raspberry')
      ? 'raspberry'
      : null
    let useUnlabeledButton = this.dataset.useUnlabeledButton === 'true'
    let useUnlabeledButtonInst = this.dataset.useUnlabeledButtonInst === 'true'
    let useInlineButton = this.dataset.useInlineButton === 'true'
    let useCheckBoxButton = this.dataset.useCheckBoxButton === 'true'
    let openModalWithQueryString = this.dataset.openModalWithQueryString

    let subscribeCustomText = this.dataset.subscribeCustomText
    let unsubscribeCustomText = this.dataset.unsubscribeCustomText

    const thoughtLeadershipDataString = document.getElementById(
      'cesc-thought-leadership-data'
    )
    let thoughtLeadershipData = thoughtLeadershipDataString
      ? JSON.parse(thoughtLeadershipDataString.innerHTML)
      : []

    const topicDataString = document.getElementById('cesc-topic-data')
    let topicData = topicDataString ? JSON.parse(topicDataString.innerHTML) : []

    const authorDataString = document.getElementById('cesc-author-data')
    let authorData = authorDataString
      ? JSON.parse(authorDataString.innerHTML)
      : []

    // parse out the data into an array of names
    let subscriptionNameList = []

    if (thoughtLeadershipData) {
      subscriptionNameList = [...thoughtLeadershipData, ...subscriptionNameList]
    }
    if (topicData) {
      subscriptionNameList = [...topicData, ...subscriptionNameList]
    }
    if (authorData) {
      subscriptionNameList = [...authorData, ...subscriptionNameList]
    }

    if (this.dataset.subscriptionName) {
      if (useUnlabeledButton || useUnlabeledButtonInst || useCheckBoxButton) {
        subscriptionNameList = [this.dataset.subscriptionName]
      } else {
        subscriptionNameList.push(this.dataset.subscriptionName)
      }
    }

    subscriptionNameList = dedupeAndRemoveEscapeChar(subscriptionNameList)

    // pass the name list to get the actual subscriptions
    if (subscriptionNameList.length > 0) {
      subscriptions = await getSubscriptionsByNameList(subscriptionNameList)
    }

    // update the subscriptions from the auth state
    if (isLoggedIntoSubscriptionCenter()) {
      subscriptionProfile = await getSubscriptionsForUser()
      if (subscriptionProfile && subscriptions.length > 0) {
        subscriptions = updateSubscriptionData(subscriptionProfile.value, {
          subscriptions,
        })
      }
    }

    const categorySortList = setAndSortModalCategories(
      this.dataset.categorySortOrder
    )

    // subscription that are parsed and updated from auth state
    subscriptions = subscriptions?.sort((a, b) => {
      const aScore = categorySortList.indexOf(a.category)
      const bScore = categorySortList.indexOf(b.category)

      if (aScore > bScore) {
        return 1
      } else if (aScore < bScore) {
        return -1
      } else {
        return 0
      }
    })

    // we determine which button to show
    let subscriptionId = this.dataset.subscriptionId
    let alwaysDisplayModal = this.dataset.alwaysDisplayModal

    if (subscriptions?.length === 1) {
      subscriptionId = subscriptions[0].id
      if (subscriptions[0].name === 'Education Savings') {
        subscribeCustomText = 'Subscribe to Education Savings'
        unsubscribeCustomText = 'Subscribed to Education Savings'
      }
    }

    const reactContainerId =
      'email-subscription-center-modal-react-app' + Math.random()
    let reactContainer = document.createElement('span')
    reactContainer.setAttribute('id', reactContainerId)
    this.appendChild(reactContainer)

    const container = document.getElementById(reactContainerId)
    const root = createRoot(container)

    root.render(
      <>
        {!alwaysDisplayModal && subscriptionId && (
          <SubscribeModalButton
            subscriptionProfile={subscriptionProfile}
            useUnlabeledButton={useUnlabeledButton}
            useUnlabeledButtonInst={useUnlabeledButtonInst}
            useInlineButton={useInlineButton}
            useCheckBoxButton={useCheckBoxButton}
            subscriptionId={subscriptionId}
            buttonStyle={buttonStyle}
            subscribeCustomText={subscribeCustomText}
            unsubscribeCustomText={unsubscribeCustomText}
            openModalWithQueryString={openModalWithQueryString}
          />
        )}
        {(alwaysDisplayModal || !subscriptionId) &&
          subscriptions &&
          subscriptions.length > 0 && (
            <ModalButton subscriptions={subscriptions} />
          )}
      </>
    )
  }
}
if (!customElements.get('email-subscription-modal')) {
  customElements.define(
    'email-subscription-modal',
    EmailSubscriptionCenterModalElement
  )
}
